import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { getXmppLogin, getDeviceName } from "src/modules/auth/duck/selectors";
import Dialog from "src/components/Dialog";
import NavigationButtons from "src/components/NavigationButtons";
import { resetPairingCode } from "../../duck/actions";
import { getPairingCode } from "../../duck/selectors";
import { fetchPairingCode } from "../../duck/epics";
import View from "./View";

export default function DisplayCode({ flow, closeWizard, mode, ...rest }) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const pairingCode = useSelector(getPairingCode);
  const xmppLogin = useSelector(getXmppLogin);
  const deviceName = useSelector(getDeviceName);

  const { value, error } = pairingCode;
  const code = value ? value.code : null;

  useEffect(() => {
    if (
      pairingCode.value === null ||
      new Date(pairingCode?.value?.expirationDate) < Date.now()
    ) {
      dispatch(fetchPairingCode({ deviceName, xmppLogin }));
    }
  }, [deviceName, dispatch, pairingCode.value, xmppLogin]);

  useEffect(() => {
    return () => {
      if (pairingCode.error) dispatch(resetPairingCode());
    };
  }, [dispatch, pairingCode]);

  return (
    <>
      <Dialog
        isOpen={error}
        type="failure"
        heading={t("pairing.manually.displayCode.failure.heading")}
        text={t("pairing.manually.displayCode.failure.text")}
        buttons={[{ text: t("buttons.ok"), onClick: flow.previous }]}
      />
      <NavigationButtons
        onBack={flow.previous}
        onClose={closeWizard}
        mode={mode}
      />
      <View code={code} mode={mode} {...rest} />
    </>
  );
}
